export default {
    'fumigation-certificates': 'Certificados de fumigación',
    'fumigation-certificate': 'Certificado de fumigación',
    'add-a-fumigation-certificate': 'Agregar certificado de fumigación',
}